import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { MemoCardContentDb } from '../redux/memoCardContentDbSlice';

const useMemoCardContentDb = (cardId: string | undefined): [string | undefined, MemoCardContentDb | undefined] => {
  const memoCardContentDb = useSelector((state: RootState) => state.memoCardContentDb);
  const ids = Object.keys(memoCardContentDb.memoCardContents).filter(id => memoCardContentDb.memoCardContents[id].cardId === cardId);
  if (ids.length !== 1) return [undefined, undefined];
  const id = ids[0];
  const value = memoCardContentDb.memoCardContents[id];

  return [id, value];
}

export default useMemoCardContentDb;
